import { Menu, MenuItem, Typography } from '@mui/material';

const USER_MENU_OPTIONS = ['Cerrar sesión'];

function Usermenu({ anchorElUser, handleCloseUserMenu, logOut }: any) {
    return (
        <Menu
            sx={{ mt: '45px' }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
        >
            {USER_MENU_OPTIONS.map((option: string) => (
                <MenuItem key={option} onClick={() => logOut()}>
                    <Typography sx={{ textAlign: 'center' }}>{option}</Typography>
                </MenuItem>
            ))}
        </Menu>
    );
}

export default Usermenu;
